export default __webpack_public_path__ + "static/media/report.1dd27dbf.svg";